import { readOnly } from '@ember/object/computed';
import Controller, { inject as controller } from '@ember/controller';
import ObjectsListController from 'cio/pods/objects/type/list/controller';

export default class LoadingController extends Controller {
  @controller('objects.type.list') listController!: ObjectsListController;
  @readOnly('listController.totalColumns') totalColumns!: ObjectsListController['totalColumns'];
}
